import React from 'react';
import './NewOrder.css';
import { useState,useEffect } from 'react';
import axios from 'axios';
import { var_api,image_api } from '../../constant';
import Swal from 'sweetalert2';
import { useHistory } from 'react-router-dom';
import Select from 'react-select';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import Layout from '../../NewHeader/Layout';
import cimage from '../../../images/burger/b3.png';
import { Row, Col, Card } from 'react-bootstrap';
import { Bar } from 'react-chartjs-2';
import Table from 'react-bootstrap/Table';
import Pagination from 'react-js-pagination';
import Loader from '../../Loader/Loader';
import profile from '../../../images/splash/avatar.png';

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

// Register the required components with Chart.js
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const NewOrder = () => {
  const history = useHistory();
  const [show, setShow]  = useState(false);
  const [activeOrder, setActiveOrder] = useState([]);
  const [shops, setShops] = useState([]);
  const [selectedShop, setSelectedShop] = useState(null);
  const [ searchQuery,setSearchQuery] = useState('');
  const [fromDate, setFromDate] = useState("");
  const [ isEdit,setIsEdit ] = useState(false);
  const [ isOpenAssign, setIsOpenAssign ] = useState(false);
  const [ activeDeliveryPerson, setactiveDeliveryPerson ] = useState([]);
  const [ activeDeliveryPersonList, setactiveDeliveryPersonList ] = useState([]);
  const [ activeDeliveryNumbers, setActiveDeliveryPerson ] = useState([]);
  const [bookingOrder, setBookingorders] = useState([]);
  const [ itempopup, setItempopup ] = useState(false);
  const [ orderedItems, setorderItems ] = useState([]);
  const [ setOrdereditempopup, setOrderedItempopup ] = useState(false);
  const [ orderNo, setOrderNo ] = useState('');
  const [ updateId, setupdateId ] = useState('');
  const [ assignparticular, setIsOpenAssignparticular ] = useState(false);
  const [ assignedOrderNo, setassignedpopupno ] = useState('');
  const [ activeDeliveryPersonListParticular, setactiveDeliveryPersonListParticular] = useState([]);
  const [ currentOrder, setCurrentOrder] = useState(false);

  
  const getCurrentDate = () => {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = ("0" + (currentDate.getMonth() + 1)).slice(-2);  // Add leading zero to month
    const day = ("0" + currentDate.getDate()).slice(-2);  // Add leading zero to day
    return `${year}-${month}-${day}`;
  };

  // Function to format date as DD-MM-YYYY
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = ("0" + date.getDate()).slice(-2);  // Add leading zero to day
    const month = ("0" + (date.getMonth() + 1)).slice(-2);  // Add leading zero to month
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;  // Return in DD-MM-YYYY format
  };

  const [selectedDeliveryPerson, setSelectedDeliveryPerson] = useState(null); // Selected delivery person
  const [selectedOrderIds, setSelectedOrderIds] = useState([]); // Selected booking order IDs
  
  const [particularId, setparticularid] = useState(''); // Selected booking order IDs

  
  const [ isCreate,setCreate ] = useState(false);
  const [selectAll, setSelectAll] = useState(false);
  const [selectedCheckboxes, setSelectedCheckboxes] = useState(
    activeOrder.map(() => false) // Initializing each checkbox state as unchecked
  );
  const [ loading, setLoading ] = useState(false);
  const [ postloading,setPostLoading ] = useState(false);
  const [EmployeeD, setEmployeeD] = useState({});
  const [formData, setFormData] = useState({
    e_name: "", 
    e_email: null, 
    e_password: null,
    e_phone: null,
    e_role: "",
    profile: null,
    shops: [],
    user_id: localStorage.getItem("userId")
});

  const chartData = {
    labels: activeDeliveryNumbers.map(person => person.name),
    datasets: [
      {
        label: 'Count',
        data: activeDeliveryNumbers.map(person => person.delivery_count),
        backgroundColor: 'rgba(75, 192, 192, 0.6)', // Bar color
        borderColor: 'rgba(75, 192, 192, 1)',
        borderWidth: 1,
      },
    ],
  };

  // Chart configuration options
  const options = {
    responsive: true,
    scales: {
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: 'Count',
        },
      },
      x: {
        title: {
          display: true,
          text: 'Person',
        },
      },
    },
  };

    useEffect(() => {
      const currentDate = getCurrentDate();
    fetchTables();
    fetchActivecustomer();
    // fetchActivecustomerParticular();
    fetchActiveDeliveryPersons(formatDate(currentDate));
      }, []);


        // Effect to detect when fromDate becomes empty
  useEffect(() => {
    if (fromDate === '') {
      fetchTables();
    }
  }, [fromDate]);

     const fetchTables = async (date = null) => {
        setLoading(true);

        const shop_id = localStorage.getItem('ShopId');
        const token = localStorage.getItem('Token');
        try {
           
            const url = date
            ? `${var_api}booking-orders/active-order-list/${shop_id}/${date}`
            : `${var_api}booking-orders/active-order-list/${shop_id}`;
          
          const response = await axios.get(url, {
            headers: {
              Authorization: `${token}` // Ensure correct token format
            }
          });
            setLoading(false);
            console.log("Response received:", response);
            setItempopup(false);
            const user = response.data.data || [];
            setActiveOrder(user);
            console.log("Selexcted ID"+localStorage.getItem('SelectedBookingId'));
            matchAndOpenPopup(localStorage.getItem('SelectedBookingId'));
        } catch (error) {
            setLoading(false);
            setActiveOrder([]);
            if (error.response && error.response.status === 401) {
              localStorage.removeItem('Token'); // Clear the invalid token
              history.push('/')// Redirect to the Sign-In page
            } else {
              console.error("Error fetching data:", error);
            }
        }
    };



      const fetchTableStatus= async (date = null) => {
        setLoading(true);
    
        const shop_id = localStorage.getItem("ShopId");
        const token = localStorage.getItem("Token");
        try {
            const url = date
                ? `${var_api}booking-orders/active-order-list/${shop_id}/${date}`
                : `${var_api}booking-orders/active-order-list/${shop_id}`;
            
            const response = await axios.get(url, {
                headers: {
                    Authorization: `${token}`,
                },
            });
    
            setLoading(false);
            console.log("Response received:", response);
    
            // Update activeOrder with fetched data
            const user = response.data.data || [];
            setActiveOrder(user);
    
            // Match and open popup using the updated data
            const selectedId = localStorage.getItem("SelectedBookingId");
            const matchedOrder = user.find(order => order.id == selectedId); // Directly use the response data
    
            if (matchedOrder) {
                setBookingorders(matchedOrder.booking_dates || []);
                setItempopup(true); // Open popup after matching data
            } else {
                console.error("No matching order found for SelectedBookingId");
            }
        } catch (error) {
            setLoading(false);
            setActiveOrder([]);
            if (error.response && error.response.status === 401) {
              localStorage.removeItem('Token'); // Clear the invalid token
              history.push('/')// Redirect to the Sign-In page
            } else {
              console.error("Error fetching data:", error);
            }
        }
    };
    

    //list the delivery person names
    const fetchActivecustomer = async () => {
      setLoading(true);

      const shop_id = localStorage.getItem('ShopId');
      const token = localStorage.getItem('Token');
      try {
          const response = await axios.get(
              `${var_api}delivery-person-management/get-cust-list/${shop_id}`,
              {
                  headers: {
                      Authorization: `${token}`, // Add the token to the Authorization header dynamically
                  },
              }
          );
          setLoading(false);
          console.log("Response received:", response);

          const user = response.data || [];
          setactiveDeliveryPerson(user);
          const deliveryPersonOptions = (response.data || []).map((person) => ({
            value: person.id, // Replace with the unique identifier
            label: person.name, // Replace with the name field
        }));
        setactiveDeliveryPersonList(deliveryPersonOptions);
      } catch (error) {
          setLoading(false);
          setactiveDeliveryPerson([]);
          if (error.response && error.response.status === 401) {
            localStorage.removeItem('Token'); // Clear the invalid token
            history.push('/')// Redirect to the Sign-In page
          } else {
            console.error("Error fetching data:", error);
          }
      }
  };


  //list delivery person name for particular assigning
  const fetchActivecustomerParticular = async (date, from_time, to_time) => {
    setLoading(true);

    const shop_id = localStorage.getItem('ShopId');
    const token = localStorage.getItem('Token');
    try {
        const response = await axios.get(
            `${var_api}delivery-person-management/get-cust-list/${shop_id}`,
            // `${var_api}delivery-person-management/delivery-person-management/free-delivery-person-list/${shop_id}/${date}/${from_time}/${to_time}`,
            {
                headers: {
                    Authorization: `${token}`, // Add the token to the Authorization header dynamically
                },
            }
        );
        setLoading(false);
        console.log("Response received:", response);

        // const user = response.data || [];
        // setactiveDeliveryPerson(user);
        const deliveryPersonOptions = (response.data || []).map((person) => ({
          value: person.id, // Replace with the unique identifier
          label: person.name, // Replace with the name field
      }));
      setactiveDeliveryPersonListParticular(deliveryPersonOptions);
    } catch (error) {
        setLoading(false);
        if (error.response && error.response.status === 401) {
          localStorage.removeItem('Token'); // Clear the invalid token
          history.push('/')// Redirect to the Sign-In page
        } else {
          console.error("Error fetching data:", error);
        }
        // setactiveDeliveryPerson([]);
    }
};



  const fetchActiveDeliveryPersons = async (selectedDate) => {
    setLoading(true);

    const shop_id = localStorage.getItem('ShopId');
    const token = localStorage.getItem('Token');
    try {
        const response = await axios.get(
            `${var_api}booking-orders/delivery-person-count/${shop_id}/${selectedDate}`,
            {
                headers: {
                    Authorization: `${token}`, // Add the token to the Authorization header dynamically
                },
            }
        );
        setLoading(false);
        console.log("Response received:", response);

        const user = response.data.data || [];
        setActiveDeliveryPerson(user);
        
    } catch (error) {
        setLoading(false);
        setActiveDeliveryPerson([]);
        if (error.response && error.response.status === 401) {
          localStorage.removeItem('Token'); // Clear the invalid token
          history.push('/')// Redirect to the Sign-In page
        } else {
          console.error("Error fetching data:", error);
        }
    }
};


    const handleDateChange = (event) => {
      const selectedDate = event.target.value;
      setFromDate(selectedDate);  // Update state with selected date
      fetchTables(formatDate(selectedDate)); // Fetch data with the selected date
      fetchActiveDeliveryPersons(formatDate(selectedDate)); 
    };



//handle image change
    const handleImageChange = (e) => {
        const file = e.target.files[0];
        console.log("files",file);
        setFormData({ ...formData, profile: file });
      };

//handle text field change
const handleInputChange = (event) => {
  const { name, value } = event.target;
  setFormData({
    ...formData,
    [name]: value
  });
};

  // Function to capitalize the first letter of a string
  const capitalize = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
   };
  

      //post the form data
    const Submit = async (e) => {
      e.preventDefault();
      setPostLoading(true);

      try {

        const camelCaseEName = capitalize(formData.e_name);

        const formDataToSend = new FormData();
        // Append all form fields to the FormData object
        formDataToSend.append('e_name', camelCaseEName);
        formDataToSend.append('e_email', formData.e_email);
        formDataToSend.append('e_password', formData.e_password);
        formDataToSend.append('e_phone', formData.e_phone);
        formDataToSend.append('e_role', formData.e_role);
        formDataToSend.append('profile', formData.profile);
        formDataToSend.append('user_id', formData.user_id);
    
        // Append shop data (if any)
        formData.shops.forEach((shop, index) => {
          formDataToSend.append(`shops[${index}][shop_name]`, shop.shop_name);
          formDataToSend.append(`shops[${index}][shop_id]`, shop.shop_id);
          formDataToSend.append(`shops[${index}][is_active]`, shop.is_active);
        });
        

        const response = await axios.post(`${var_api}/api/employees/post`, formDataToSend, {
            headers: {
                'Content-Type': 'multipart/form-data' // Set content type to multipart/form-data
            }
        });
        const result = response.data;
        console.log("rrrr",result);
        if(result.message === "Employee created successfully"){
          setCreate(false);
          const currentDate = getCurrentDate();
          fetchTables(formatDate(currentDate));
          setPostLoading(false)
          Swal.fire({
            icon:"success",
            text:'Employee Created Successfully',
            confirmButtonColor:"#007500"
          })

          setFormData({...formData,
            e_name: "", 
            e_email: " ", 
            e_password: "",
            e_phone: "",
            e_role: "",
            profile: " "
          })
          

        }
        // Handle successful response (e.g., show a success message to the user)
      } catch (error) {
        // Handle request failure
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      setPostLoading(false)

      console.error('Server responded with error status:', error.response.status);
      if (error.response.data && error.response.data.message) {
        setPostLoading(false)
       
        Swal.fire({
          icon:"error",
          text: error.response.data.message,
          confirmButtonColor:"#007500"
        })
      } else {
        alert('An error occurred. Please try again later.');
      }
    } else if (error.request) {
      // The request was made but no response was received
      console.error('No response received from the server:', error.request);
      setPostLoading(false)
      alert('No response received from the server. Please try again later.');
    } else {
      // Something happened in setting up the request that triggered an Error
      console.error('Error occurred while setting up the request:', error.message);
      setPostLoading(false)
      alert('An error occurred. Please try again later.');
    }
        
      }
    };



    //Go to home page
    const handleButtonClick = () => {
      history.push('/AdminHome')
    }


    const handleStatusChange = async (status, slotId, bookingDateId, slotName) => {
      try {
          const token = localStorage.getItem('Token');
          
          // Make the PUT request
          const response = await axios.put(
              `${var_api}booking-orders/update-order-status/${updateId}`,
              {
                  slot_status: status,
                  booking_slot_id: slotId,
                  booking_date_id: bookingDateId,
              },
              {
                  headers: {
                      Authorization: `${token}`,
                  },
              }
          );
  
          if (response.data.success) {
              Swal.fire({
                  icon: "success",
                  text: `Slot Name ${slotName} Order status updated to ${
                      status === 1 ? "In Progress" : "Packed"
                  }`,
                  confirmButtonColor: "#007500",
              });
              console.log(`Order status updated to ${status === 1 ? "In Progress" : "Packed"}`);
  
              // Close popup and reload data
              setItempopup(false);
              await fetchTableStatus(); // Ensure data is reloaded before proceeding
          }
      } catch (error) {
        if (error.response && error.response.status === 401) {
          localStorage.removeItem('Token'); // Clear the invalid token
          history.push('/')// Redirect to the Sign-In page
        } else {
          console.error("Error fetching data:", error);
        }
      }
  };
    


  const handleAssigningDeliveryPerson = async () => {
    try {
      const token = localStorage.getItem('Token'); // Retrieve the token
      const shop_id = localStorage.getItem('ShopId');
      if (!selectedDeliveryPerson || selectedOrderIds.length === 0) {
        alert("Please select a delivery person and at least one booking order.");
        return;
      }
  
      // Prepare the payload
      const payload = {
        id: selectedOrderIds, // Selected booking order IDs
        delivered_by: selectedDeliveryPerson, // Selected delivery person ID
      };
  
      // Make the PUT request
      const response = await axios.put(
        `${var_api}booking-orders/assign-delivery-person/${shop_id}`,
        payload,
        {
          headers: {
            Authorization: `${token}`,
          },
        }
      );
  
      if (response.data.success) {
        // Find the delivery person details
        const assignedPerson = activeDeliveryPerson.find(
          (person) => person.id === selectedDeliveryPerson
        );
  
        if (assignedPerson) {
          // Show SweetAlert with name and image
          Swal.fire({
            title: `<div style="font-size: 1.2em; font-weight: bold; color: #4caf50;">Delivery Person Assigned</div>`,
            html: `<div style="display: flex; align-items: center; flex-direction: column; gap: 10px;">
                           <span style="font-size: 1.2em; font-weight: bold;">Order ID:${assignedOrderNo}</span>
  
               <img 
                 src="${profile}" 
                 alt="${assignedPerson.name}" 
                 style="width: 80px; height: 80px; border-radius: 50%; border: 2px solid #4caf50;" 
               />
               <span style="font-size: 1.2em; font-weight: bold;">${assignedPerson.name}</span>
             </div>`,
            icon: "success",
            confirmButtonText: "OK",
            buttonsStyling: false,
            customClass: {
              confirmButton: "custom-swal-btn",
              popup: "custom-swal-popup",
            },
          });
        }
  
        fetchTables(); // Refresh the table
        setIsOpenAssign(false); // Close the modal
        setSelectedOrderIds([]);
        setSelectedDeliveryPerson(null);
        setSelectedCheckboxes([]);
        
        // Refresh the page
        window.location.reload(); // This will reload the entire page
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.removeItem('Token'); // Clear the invalid token
        history.push('/')// Redirect to the Sign-In page
      } else {
        console.error("Error  assigning delivery person:", error);
      }
    }
  };
  
    const handleAssigningParticularDeliveryPerson = async () => {
      try {
        const token = localStorage.getItem('Token'); // Retrieve the token
        const shop_id = localStorage.getItem('ShopId');
        if (!selectedDeliveryPerson === 0) {
          alert("Please select a delivery person");
          return;
        }
    
        // Prepare the payload
        const payload = {
          delivered_by: selectedDeliveryPerson // Selected delivery person ID
        };
        // http://api.theherbandwatercompany.com/v1/booking-orders/slots-assign-delivery-person/put/4
        // Make the PUT request
        const response = await axios.put(
          `${var_api}booking-orders/slots-assign-delivery-person/put/${particularId}`,
          payload,
          {
            headers: {
              'Authorization': `${token}`
            }
          }
        );
    
        if (response.data.success) {

          const assignedPerson = activeDeliveryPerson.find(
            (person) => person.id === selectedDeliveryPerson
          );
    
          if (assignedPerson) {
            // Show SweetAlert with name and image
            Swal.fire({
              title: `<div style="font-size: 1.2em; font-weight: bold; color: #4caf50;">Delivery Person Assigned</div>`,
              html: `<div style="display: flex; align-items: center; flex-direction: column; gap: 10px;">
                                     <span style="font-size: 1.2em; font-weight: bold;">Order ID:${orderNo}</span>

                       <img 
                         src="${profile}" 
                         alt="${assignedPerson.name}" 
                         style="width: 80px; height: 80px; border-radius: 50%; border: 2px solid #4caf50;" 
                       />
                       <span style="font-size: 1.2em; font-weight: bold;">${assignedPerson.name}</span>

                       
                     </div>`,
              icon: "success",
              confirmButtonText: "OK",
              buttonsStyling: false,
              customClass: {
                confirmButton: "custom-swal-btn",
                popup: "custom-swal-popup",
              },
            });
          }
          setIsOpenAssignparticular(false);
          fetchTableStatus();
          setItempopup(false);
          setItempopup(true);
          console.log("Delivery person assigned successfully.");
          setIsOpenAssign(false); // Close the modal
        }
      } catch (error) {
        if (error.response && error.response.status === 401) {
          localStorage.removeItem('Token'); // Clear the invalid token
          history.push('/')// Redirect to the Sign-In page
        } else {
          console.error("Error  assigning delivery person:", error);
        }
      }
    };
    

  const handleSelectAllChange = () => {
    setSelectAll(!selectAll);
    setSelectedCheckboxes(activeOrder.map(() => !selectAll));
  };

  const handleCheckboxChange = (index, id,deliveryBy,orderNo) => {
    const updatedCheckboxes = [...selectedCheckboxes];
    updatedCheckboxes[index] = !updatedCheckboxes[index];
  
    if (updatedCheckboxes[index]) {
      setSelectedOrderIds([...selectedOrderIds, id]); // Add order ID
      setSelectedDeliveryPerson(deliveryBy);
      console.log(setSelectedDeliveryPerson(deliveryBy));
      setassignedpopupno(orderNo);

      console.log(deliveryBy);
    } else {
      setSelectedOrderIds(selectedOrderIds.filter((id) => id !== id)); // Remove order ID
      console.log(selectedOrderIds);
      setSelectedDeliveryPerson(null);

    }
  
    setSelectedCheckboxes(updatedCheckboxes); // Update checkbox state
  };

  const handleshow =(data,dataId)=>{
    setBookingorders(data);
    setItempopup(true);
    localStorage.setItem('SelectedBookingId', dataId);
  }

  
  const handleshowItems =(data)=>{
    setorderItems(data);
    setOrderedItempopup(true);
  }

const handelOrderNo =(data)=>{
  setOrderNo(data.order_no);
  setupdateId(data.id);
  setCurrentOrder(data);
  console.log(orderNo +'---'+updateId)
}

const [currentPage, setCurrentPage] = useState(1);
 const [itemsPerPage] = useState(10); // Number of items per page
 const [searchTerm, setSearchTerm] = useState('');
 
 // Filtering tables based on search term
 const filteredTables = activeOrder.filter((item) => {
  const orderType = item.order_type === 1 ? "Normal Order" : item.order_type === 2 ? "Credit Order"  : "-";
  const payment = item.payment_status === 1 ? "Paid"  : "Not Paid";
  const orderStatus = item.order_status === 0 ? "New" : item.order_status === 1 ? "Partial"  :item.order_status === 2 ? "Completed":item.order_status === 4 ? "Cancelled": "Cancelled";

   return (
     item.booking_dates[0]?.date.toLowerCase().includes(searchTerm.toLowerCase()) || 
     String(item.mobile_no).toLowerCase().includes(searchTerm.toLowerCase()) ||
     String(item.order_no).toLowerCase().includes(searchTerm.toLowerCase()) ||

     String(item.delivery_person_name).toLowerCase().includes(searchTerm.toLowerCase()) ||
     String(item.delivered_address).toLowerCase().includes(searchTerm.toLowerCase())||
     String(item.customer_name).toLowerCase().includes(searchTerm.toLowerCase()) ||
     String(item.amount).toLowerCase().includes(searchTerm.toLowerCase()) ||
     orderType.toLowerCase().includes(searchTerm.toLowerCase()) ||
     payment.toLowerCase().includes(searchTerm.toLowerCase()) ||
     orderStatus.toLowerCase().includes(searchTerm.toLowerCase()) 

    //  item.slot_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    //  String(item.delivery_date).toLowerCase().includes(searchTerm.toLowerCase()) ||
    //  String(item.amount).toLowerCase().includes(searchTerm.toLowerCase()) 
   );
 });
 
 // Pagination logic
 const indexOfLastItem = currentPage * itemsPerPage;
 const indexOfFirstItem = indexOfLastItem - itemsPerPage;
 const currentItems = filteredTables.slice(indexOfFirstItem, indexOfLastItem);
 const totalItems = filteredTables.length;
 
 const handleSearchInput = (event) => {
   setSearchTerm(event.target.value);
   setCurrentPage(1); // Reset to the first page when search changes
 };
 
 const handlePageChange = (pageNumber) => {
   setCurrentPage(pageNumber);
 };

 const handleparticularassign =(data,deliveryBy,slotName, date, from_time, to_time)=>{
  fetchActivecustomerParticular(date, from_time, to_time);
    setparticularid(data);
    setSelectedDeliveryPerson(deliveryBy);
    setIsOpenAssignparticular(true);
    console.log(data,deliveryBy,slotName, date, from_time, to_time);
 }

 const matchAndOpenPopup = (selectedId) => {
  const matchedOrder = activeOrder.find(order => order.id == selectedId);
  if (matchedOrder) {
      setBookingorders(matchedOrder.booking_dates || []); // Set matched booking_dates[]
      setItempopup(true); // Open popup
  } else {
      console.error("No matching order found");
  }
};

 const [showGroupModal, setShowGroupModal] = useState(false);
  const [selectedGroupFoods, setSelectedGroupFoods] = useState([]);

  const handleGroupClick = (groupFoods) => {
    setSelectedGroupFoods(groupFoods);
    setShowGroupModal(true);
  };

    return(
      <>         <Layout>
            <div class="splitno">
              <Row>
              <Col lg={fromDate ? 8 : 12}>
      <div style={{border:"none", padding:"15px", width:"103%", minHeight:"640px",margin:"auto",borderRadius:"10px",backgroundColor:"white",boxShadow:" rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 56px, rgba(17, 17, 26, 0.1) 0px 24px 80px", marginTop:"20px"}}>
    
      {/* <Button variant='dark'className='mb-4' onClick={handleCreateEmployee}   style={{fontSize:"17px",float:"right",borderRadius:"10px"}}>Create Category</Button>{' '}
       */}
      <div>
    
     
      <div className="row" style={{ margin: "0", gap: "5px", marginRight:"10px" }}> {/* Reduced gap */}
  <div className="col" style={{ padding: "0" }}>
    <h4 className='usheomno'>ACTIVE ORDERS</h4>
  </div>
  
  <div className="col" style={{ padding: "0" }}>
    {/* Empty Column */}
  </div>
  
  <div className="col" style={{ maxWidth: "250px", padding: "0" }}>
        <input
          type="date"
          className="form-control form-control-sm"
          id="fromDate"
          name="fromDate"
          style={{ fontSize: "15px", float: "right" }}
          value={fromDate}  // Bind the value to the selected date
          onChange={handleDateChange}  // Call the handler when the date is changed
        />
      </div>
  
  <div className="col" style={{ padding: "0" }}>
    <input
      className="form-control"
      type="search"
      placeholder="Search"
      style={{
        maxWidth: "230px",
        borderRadius: "10px",
        border: "1px solid black",
        float: "right",
      }}
      onChange={handleSearchInput}
    />
  </div>

  <div className="col" style={{ maxWidth: "350px", padding: "0" }}>
    <Button
      variant="dark"
      size="sm"
      style={{ padding: "2px 8px", fontSize: "17px", float: "right", borderRadius: "10px" }}
      onClick={() => setIsOpenAssign(true)}
    >
      Assign to Delivery Person
    </Button>
  </div>
</div>

      <div className="table-container" style={{ height:"540px", overflowX: 'auto', overflowY: 'scroll', marginTop:"5px" }}>
      <table class="table table-hover small-first-col" style={{border:"none",borderColor:"grey",width:"95%",margin:"auto"}}>
  <thead>
    <tr style={{fontWeight:"bolder"}}>
    {/* <th scope="row" style={{ textAlign: "left" }}>
       <input
          type="checkbox"
          className="custom-checkbox" // Add custom class
          checked={selectAll}
          onChange={handleSelectAllChange}
        />
      </th> */}
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">S.No</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Delivery Date</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Delivery Person Name</th>

      {/* <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Delivery Date</th> */}
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Delivery Address</th>
      {/* <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Deliver By</th> */}
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Order No</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Order Type</th>
      {/* <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Slot Type</th> */}
      {/* <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Slot Name</th> */}
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Customer name</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Mobile</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Amount</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Payment Status</th>      
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Paymode</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Status</th>

      {/* <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Paymode</th> */}
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Action</th>
    </tr>
  </thead>
  {loading ? (
        <Loader/>
  ) : 
  <tbody style={{fontSize:"14.5px"}}>
  {currentItems.length > 0 ? (
    currentItems.map((data, index) => (
      <tr key={data.sNo} style={{ padding: "4px" }}>
        {/* <th scope="row" style={{ textAlign: "left" }}>
          <input
            type="checkbox"
            className="custom-checkbox"
            checked={selectedCheckboxes[index]}
            onChange={() => handleCheckboxChange(index, data.id,data.delivery_person_name,data.order_no)} // Pass order ID
          />
        </th> */}
        <th scope="row" style={{ textAlign: "left" }}>{indexOfFirstItem + index + 1}</th>
        <td style={{ textTransform: "capitalize", textAlign: "left" }}>
          {data.booking_dates[0]?.date || '-'}
        </td>
      
        <td style={{ textAlign: "left" }}>{data.delivery_person_name || '-'}</td>
        {/* <td style={{ textAlign: "left" }}>{data.delivered_date}</td> */}
        <td style={{ textAlign: "left" }}>{data.delivery_address}</td>
        <td style={{ textAlign: "left", color:"blue"  }}>{data.order_no}</td>
        <td style={{ textAlign: "left", color: data.order_type === 1 ? "purple" :  data.order_type === 2 ? "orange"  : "grey", fontWeight: "bold" }}>
        {data.order_type === 1 ? "Normal Order" : data.order_type === 2 ? "Credit Order"  : "Pending"}
        </td>
        {/* <td style={{ textAlign: "left" }}>{data.slot_type === 0 ? "Single Slot" : "Multi-slot"}</td> */}
        {/* <td style={{ textAlign: "left" }}>{data.slot_name}</td> */}
        <td style={{ textAlign: "left" }}>{data.customer_name}</td>
        <td style={{ textAlign: "left" }}>{data.mobile_no}</td>
        <td style={{ textAlign: "left" }}>${data.amount}</td>
        <td style={{ textAlign: "left", color: data.payment_status === 0 ? "red" : "green", fontWeight: "bold" }}>
          {data.payment_status === 0 ? "Not Paid" : "Paid"}
        </td>
        <td style={{ textTransform: "capitalize", textAlign: "left" }}>{data.paymode_name}</td>
        <td style={{
          textAlign: "left",
          color: data.order_status === 0 ? "blue" :
                 data.order_status === 1 ? "orange" :
                 data.order_status === 2 ? "green" :
                 data.order_status === 3 ? "red" : "gray",
          fontWeight: "bold",
        }}>
          {data.order_status === 0 ? "New" :
           data.order_status === 1 ? "Partial" :
           data.order_status === 2 ? "Delivered" :
           data.order_status === 4 ? "Cancelled" : "Cancelled"}
        </td>
        <td>
          <div style={{ textAlign: "left", display: "flex", gap: "2px" }}>
            <button
              className="btn btn-primary"
              onClick={() => {
                handleshow(data.booking_dates,data.id);
                handelOrderNo(data);
              }}
                            style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
            >
              <i style={{ color: "white", fontSize: "13px" }} className="bi bi-eye-fill"></i>
            </button>
            {/* {
    data.order_status === 0 ? ( // When order_status is 0 (New)
      <>
        <Button
          variant="success"
          size="sm"
          style={{ padding: "2px 8px", fontSize: "17px" }}
          onClick={() => handleStatusChange(1,data.id)} // Change to In Progress
        >
          In Progress
        </Button>
        <Button
          variant="warning"
          size="sm"
          style={{ padding: "2px 8px", fontSize: "17px" }}
          onClick={() => handleStatusChange(2, data.id)} // Change to Packed
        >
          Pack
        </Button>
      </>
    ) : data.order_status === 1 ? ( // When order_status is 1 (In Progress)
      <>
        <Button
          variant="success"
          size="sm"
          style={{ padding: "2px 8px", fontSize: "17px" }}
          disabled // Disabled In Progress button
        >
          In Progress
        </Button>
        <Button
          variant="warning"
          size="sm"
          style={{ padding: "2px 8px", fontSize: "17px" }}
          onClick={() => handleStatusChange(2, data.id)} // Change to Packed
        >
          Pack
        </Button>
      </>
    ) : ( // When order_status is 2 or any other status
      <>
        <Button
          variant="success"
          size="sm"
          style={{ padding: "2px 8px", fontSize: "17px" }}
          disabled // Disabled In Progress button
        >
          In Progress
        </Button>
        <Button
          variant="warning"
          size="sm"
          style={{ padding: "2px 8px", fontSize: "17px" }}
          disabled // Disabled Pack button
        >
          Pack
        </Button>
      </>
    )
  } */}

          </div>
        </td>
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="16" style={{ textAlign: "center", fontWeight: "bold" }}>
        No data available
      </td>
    </tr>
  )}
</tbody>

}
</table>

<Pagination
        activePage={currentPage}
        itemsCountPerPage={itemsPerPage}
        totalItemsCount={totalItems}
        pageRangeDisplayed={5}
        onChange={handlePageChange}
        itemClass="page-item"
        linkClass="page-link"
        innerClass="pagination justify-content-end"
        activeClass="active-pagination"
      />
      </div>
      

</div>
        </div></Col>
        {fromDate && (
        <Col lg="4">
        <div style={{border:"none", padding:"15px", width:"103%", minHeight:"640px",margin:"auto",borderRadius:"10px",backgroundColor:"white",boxShadow:" rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 56px, rgba(17, 17, 26, 0.1) 0px 24px 80px", marginTop:"20px"}}>
        <div className="container" style={{padding:"0px"}}>
            <h4 className="text mb-4" style={{margin:"10px"}}>Delivery Persons</h4>
             {/* Header for the list */}

             {activeDeliveryNumbers.length > 0 ? (
            <ul className="space-y-1">
            <div className="d-flex justify-content-between font-bold border-b pb-1" style={{marginRight:"10px"}}>
    <span>Person</span>
    <span>Count</span>
  </div>
                {activeDeliveryNumbers.map((person) => (
                    <li key={person.id} className="list-item">
                      
                        <div className="d-flex justify-content-center">
                            {/* <img src={`https://placehold.co/50x50`} alt={`Placeholder image for ${person.label}`} /> */}
                            <div className="avatar">
            {person.name && person.name.charAt(0)}
          </div>
                            <span className='mt-2'>{person.name}{activeDeliveryNumbers.length}</span>
                            {/* <span className='ms-2 mt-2'>({person.assigned_location}-{person.postalCode})</span> */}
                                                        <span className='ms-2 mt-2'>({person.assigned_location})</span>


                        </div>
                        <span className="text-xl font-bold">{person.delivery_count}</span>
                    </li>
                     ))}
            </ul>
          ) : (
            <p className="text-center text-success fw-bold pt-5">Delivery Persons Not Assigned</p>
          )}
          

            {activeDeliveryNumbers.length > 0 && (
            <Bar data={chartData} options={options} style={{marginTop:"30px"}}/>
          )}
        </div>
        
        </div>
        </Col>
        )}

        </Row>
      </div>

      <Modal
  show={isOpenAssign}
  onHide={() => setIsOpenAssign(false)}
  backdrop="static"
  keyboard={false}
  size="md"
>
  <Modal.Header closeButton>
    <Modal.Title style={{ fontSize: "15px" }}>Assign Delivery Person</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <div style={{ padding: "20px" }}>
      <h6 className="text-dark" style={{ textAlign: "center", fontWeight: "bold" }}>
        Please select a delivery person from the list below:
      </h6>
      <Select
  options={activeDeliveryPersonList} // List of delivery persons
  isSearchable
  getOptionLabel={(option) => option.label} // Display label (name) as the label
  getOptionValue={(option) => option.id}   // Use id as the unique identifier
  value={activeDeliveryPersonList.find((person) => person.id = selectedDeliveryPerson)} // Match based on id
  onChange={(selectedOption) => setSelectedDeliveryPerson(selectedOption?.value)} // Update the selected id
/>


    </div>
    <Button
      variant="success"
      style={{ float: "right", marginLeft: "5px" }}
      onClick={handleAssigningDeliveryPerson} // Assign delivery person
    >
      Assign
    </Button>
    <Button
      variant="danger"
      style={{ float: "right" }}
      onClick={() => setIsOpenAssign(false)}
    >
      Close
    </Button>
  </Modal.Body>
</Modal>

<Modal
  show={assignparticular}
  onHide={() => setIsOpenAssignparticular(false)}
  backdrop="static"
  keyboard={false}
  size="md"
>
  <Modal.Header closeButton>
    <Modal.Title style={{ fontSize: "15px" }}>Assign Delivery Person</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <div style={{ padding: "20px" }}>
      <h6 className="text-dark" style={{ textAlign: "center", fontWeight: "bold" }}>
        Please select a delivery person from the list below:
      </h6>
      <Select
  options={activeDeliveryPersonListParticular} // List of delivery persons
  isSearchable
  getOptionLabel={(option) => option.label} // Display label (name) as the label
  getOptionValue={(option) => option.id}   // Use id as the unique identifier
  value={activeDeliveryPersonListParticular.find(
    (person) => person.value === selectedDeliveryPerson
  )}
  onChange={(selectedOption) =>
    setSelectedDeliveryPerson(selectedOption.value)
  }
/>


    </div>
    <Button
      variant="success"
      style={{ float: "right", marginLeft: "5px" }}
      onClick={handleAssigningParticularDeliveryPerson} // Assign delivery person
    >
      Assign
    </Button>
    <Button
      variant="danger"
      style={{ float: "right" }}
      onClick={() => setIsOpenAssignparticular(false)}
    >
      Close
    </Button>
  </Modal.Body>
</Modal>
      <Modal
        show={show}
        onHide={()=>setShow(false)}
        backdrop="static"
        keyboard={false}
        size="md" // Set size to large
      >
        <Modal.Header closeButton style={{backgroundColor:"rgba(6, 105, 16, 0.367)",padding:"22px"}}>
          {/* <Modal.Title>confirmation</Modal.Title> */}
        </Modal.Header>
        <Modal.Body>

         <div style={{padding:"20px"}}>
         <h4 style={{fontFamily:"monospace",fontWeight:"bolder",textAlign:"center"}}>CONFIRM !</h4>
          <h6 className='text-dark' style={{textAlign:"center",fontWeight:"bolder"}}>Are You Sure want to Delete Category Name 
          <span style={{color:"red",textTransform:"uppercase"}}> {EmployeeD.employee_name}</span> ?</h6> 
         </div>
         {' '} 
          <Button variant="danger" style={{float:"right"}} onClick={()=>setShow(false)}>
            Close
          </Button>{' '} 
          <Button variant="success" style={{float:"right",marginRight:"5px"}} >
            Confirm
          </Button>
        </Modal.Body>
        {/* <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseConfirmation}>
            Close
          </Button>
        </Modal.Footer> */}
      </Modal>

    

      <Modal
  show={itempopup}
  onHide={() => setItempopup(false)}
  backdrop="static"
  keyboard={false}
  size="xl"
>
  <Modal.Header closeButton>
    <Modal.Title>Delivery Dates</Modal.Title>
  </Modal.Header>
  <Modal.Body>
  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", margin:"15px 15px"}}>
  <h6>
    Order Id: <span style={{fontSize:"20px", color: "blue"}}>{currentOrder.order_no}</span>
  </h6>
  <h6 >
    Customer Name: <span style={{fontSize:"18px", color: "blue"}}>{currentOrder.customer_name}</span>
  </h6>
  <h6>
    Customer Mobile: <span style={{fontSize:"18px", color: "blue"}}>{currentOrder.mobile_no}</span>
  </h6>
</div>
    {/* Bill-Like List Design */}
    <Table hover style={{ marginBottom: "20px" }}>
      <thead>
        <tr style={{ backgroundColor: "#f8f9fa", fontWeight: "bold", color: "green" }}>
        <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">S.No</th>
          <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Delivery Date</th>
          <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Slot Name</th>
          <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">From Time</th>
          <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">To Time</th>
          <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Delivery Person</th>

          <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Order No</th>
          <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Status</th>

          <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">View List</th>
          <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Action</th>


        </tr>
      </thead>
      <tbody >
  {bookingOrder.length > 0 ? (
        (() => {
          let serialCounter = 1; // Initialize counter for Serial No
          return bookingOrder.map((dateItem, dateIndex) =>
      dateItem.slots.length > 0 ? (
        dateItem.slots.map((slot, slotIndex) => (
          <tr key={`${dateIndex}-${slotIndex}`} style={{borderBottom:"0.5px solid black"}}>
       
            <td>{serialCounter++}</td>
            <td>{dateItem.date}</td>
            <td>{slot.slot_name}</td>
            <td>{slot.from_time}</td>
            <td>{slot.to_time}</td>
            <td
 style={{
  textAlign: "center",
  display: "flex",
  borderTop: "none",
  borderBottom: "none",
  alignItems:'center',

  gap: "20px",
  alignContent: "center",
  // marginTop: "11px",
  height: "100px",
}}
>
  {slot.slot_delivery_person_name ? (
    <>
      {slot.slot_delivery_person_profile && (
        <img
          src={profile}
          alt="profile"
          style={{
            width: "30px",
            height: "30px",
            objectFit: "cover",
            borderRadius: "50%",
          }}
        />
      )}
      {slot.slot_delivery_person_name}
    </>
  ) : (
    "-"
  )}
</td>



            <td>{orderNo}</td>
            <td style={{
          textAlign: "left",
          color: slot.slot_status === 0 ? "blue" :
          slot.slot_status === 1 ? "rgb(50, 184, 23)" :
          slot.slot_status === 2 ? "rgb(184, 184, 2)" :
          slot.slot_status === 3 ? "orange" : 
          slot.slot_status === 4 ? "gray" : 
          slot.slot_status === 5 ? "green" : 
          "red",
          fontWeight: "bold",
        }}>
          {slot.slot_status === 0 ? "New" :
           slot.slot_status === 1 ? "Order Accepted" :
           slot.slot_status === 2 ? "Inprogress" :
           slot.slot_status === 3 ? "Packed" :
           slot.slot_status === 4 ? "Picked up" : 
           slot.slot_status === 5 ? "Delivered" :
           "Cancelled"}
        </td>
            <td>
              <button className="btn btn-primary" onClick={() => handleshowItems(slot.order_items)}>
                <i style={{ color: "white", fontSize: "13px" }} className="bi bi-eye-fill"></i>
              </button>
            </td>
            <td>
            <div style={{display:'flex'}}>
              {/* <div class="row">
                <div class="col"> */}
      
{/* </div> */}
    {slot.slot_status === 1 ? ( // When slot_status is 0 (New)
      <>
        <Button
          variant="success"
          size="sm"
          style={{ padding: "2px 8px", fontSize: "13px", marginRight: "8px" }}
          onClick={() =>
            handleStatusChange(2, slot.booking_slot_id, dateItem.booking_date_id, slot.slot_name)
          } // Change to In Progress
        >
          In Progress
        </Button>
        <Button
          variant="warning"
          size="sm"
          style={{ padding: "2px 8px", fontSize: "13px" }}
          onClick={() =>
            handleStatusChange(3, slot.booking_slot_id, dateItem.booking_date_id, slot.slot_name)
          } // Change to Packed
        >
          Pack
        </Button>
      </>
    ) : slot.slot_status === 2 ? ( // When slot_status is 1 (In Progress)
      <>
        <Button
          variant="success"
          size="sm"
          style={{ padding: "2px 8px", fontSize: "13px", marginRight: "8px" }}
          disabled // Disabled In Progress button
        >
          In Progress
        </Button>
        <Button
          variant="warning"
          size="sm"
          style={{ padding: "2px 8px", fontSize: "13px" }}
          onClick={() =>
            handleStatusChange(3, slot.booking_slot_id, dateItem.booking_date_id, slot.slot_name)
          } // Change to Packed
        >
          Pack
        </Button>
      </>
    ) : slot.slot_status === 5 ? ( // When slot_status is 2 (Packed)
      <Button
      variant="success"
      size="sm"
      style={{ padding: "2px 8px", fontSize: "13px" }}
      disabled // Disabled Delivered button
    >
      Delivered
    </Button>
     
    ) : (
      <>
      <Button
        variant="success"
        size="sm"
        style={{ padding: "2px 8px", fontSize: "13px", marginRight: "8px" }}
        disabled // Disabled In Progress button
      >
        In Progress
      </Button>
      <Button
        variant="warning"
        size="sm"
        style={{ padding: "2px 8px", fontSize: "13px" }}
        disabled // Disabled Pack button
      >
        Packed
      </Button>
    </>
     
    )}
              <Button
  variant="dark"
  size="sm"
  style={{ padding: "3px ", fontSize: "15px",marginLeft:'5px'}}
  onClick={() => handleparticularassign(slot.booking_slot_id,slot.delivered_by,slot.slot_name, dateItem.date, slot.from_time, slot.to_time)}
>
  {slot.delivered_by ? "Reassign Delivery Person" : "Assign to Delivery Person"}
</Button>
</div>
{/* </div> */}
            </td>

          </tr>
        ))
      ) : (
        <tr key={dateIndex}>
          <td colSpan="6" style={{ textAlign: "center", color: "red", fontWeight: "bold" }}>
            No data available
          </td>
        </tr>
      )
    );
  })()
  ) : (
    <tr>
      <td colSpan="10" style={{ textAlign: "center", color: "red", fontWeight: "bold" }}>
        No data available
      </td>
    </tr>
  )}
</tbody>

    </Table>
    {/* <button
      className="btn btn-danger"
      onClick={() => setItempopup(false)}
      style={{ borderRadius: "15px", float: "right", marginTop: "-1px" }}
    >
      Cancel
    </button> */}
  </Modal.Body>
</Modal>
<Modal
  show={setOrdereditempopup}
  onHide={() => setOrderedItempopup(false)}
  backdrop="dynamic"
  keyboard={false}
  size="xl"
  fullscreen="sm-down" // Makes it responsive for small devices
  style={{ bottom: "0", marginTop: "auto" }} // Adjusts position
>
  <Modal.Header closeButton>
    <Modal.Title>Items</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <Table hover style={{ marginBottom: "20px" }}>
      <thead>
        <tr style={{ backgroundColor: "#f8f9fa", fontWeight: "bold", color: "green" }}>
          <th>S.No</th>
          <th>Image</th>
          <th>Food Name</th>
          <th>Item Code</th>
          <th>Quantity</th>
          <th>Unit Price</th>
          <th>Variant Name</th>
          <th>Sub Variant</th>
          <th>Is Organic</th>
          <th>Remarks</th>
          <th>Additional Notes</th>
          <th>group foods</th>
        </tr>
      </thead>
      <tbody>
        {orderedItems.length > 0 ? (
          orderedItems.map((item, index) => (
            <tr key={index} style={{ borderBottom: "1px solid #ddd" }}>
              <td>{index + 1}</td>
              <td>
                <img
                  src={`${image_api}/${item.food_image}`}
                  alt="item_image"
                  width="50px"
                  height="50px"
                />
              </td>
              <td>{item.food_name}</td>
              <td>{item.item_code}</td>
              <td>{item.quantity}</td>
              <td>{item.unit_price}</td>
              <td>{item.variant_name}</td>
              <td>{item.sub_variant_name}</td>
              <td>{item.is_organic == 0 ? "Regular" : item.is_organic == 1 ? "Organic" : "N/A"}</td>
              <td>{item.remark}</td>
              <td>
  <div className="notes-cell" title={item.additional_notes}>
    {item.additional_notes}
  </div>
  </td>
  <td>
                  {item.group_items && item.group_items.length > 0 ? (
                    <span
                      style={{ color: "blue", cursor: "pointer", textDecoration: "underline" }}
                      onClick={() => handleGroupClick(item.group_items)}
                    >
                      {item.group_items.length} item(s)
                    </span>
                  ) : (
                    <span style={{ color: "gray" }}>No group foods</span>
                  )}
                </td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan="8" style={{ textAlign: "center", color: "red", fontWeight: "bold" }}>
              No data available
            </td>
          </tr>
        )}
      </tbody>
    </Table>
  </Modal.Body>
</Modal>

{/* Group Foods Modal */}
      <Modal show={showGroupModal} onHide={() => setShowGroupModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Group Foods</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedGroupFoods.length > 0 ? (
            <ul>
              {selectedGroupFoods.map((gf, idx) => (
                <li key={idx}>
                  <strong>{gf.group_name}</strong> - {gf.sub_group_name}
                </li>
              ))}
            </ul>
          ) : (
            <p>No group foods available.</p>
          )}
        </Modal.Body>
      </Modal>
    

            {/* </div> */}
       </Layout></>


    )
    
}

export default NewOrder;